import * as React from "react";
import {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";

export class AgencyHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'name': '',
        };
    }

    componentDidMount() {
        this.updateLinkedAccounts();
    }

    updateLinkedAccounts() {
        new APIClient(API_URL + 'get-agency-data/').call('GET').then((response) => {
            if (response.status === 'ERROR_NO_AGENCY') {
                alert(response.error_message);
                this.redirectToAgencyRegisterPage()
            } else if (response.status === 'OK') {
                this.setState({
                    'name': response.general_data.name,
                });
            }
        })
    }

    redirectToAgencyRegisterPage() {
        window.location.href = '/agency-register';
    }

    render() {
        return (
            <header className="section-header">
                <h1 className="section-title">{this.state.name}</h1>
            </header>
        );
    }
}